import React, { Component } from 'react'
import image1 from '../images/1212.png'
import image2 from '../images/22223.png'
import { Link } from 'react-router-dom'

export class MainSectionMP extends Component {
    render() {
        return (
            <div className='flex flex-col gap-[80px]'>
                <div className='flex justify-between items-center gap-[40px] max-[1210px]:flex-col-reverse max-[550px]:gap-[20px] max-[420px]:gap-[12px]'>
                    <div className='flex flex-col gap-[30px] w-[380px] max-[1210px]:w-full max-[1210px]:items-center max-[1210px]:gap-[16px] max-[420px]:gap-[12px]'>
                        <h2 className='font-[500] text-[40px] leading-[120%] text-[#000] max-[650px]:text-[28px] max-[650px]:text-center'>Restoran
                            Avadanlıqları</h2>
                        <p className='font-[400] text-[20px] leading-[150%] text-[#222224] max-[1210px]:w-[70%] max-[1210px]:text-center max-[650px]:text-[16px] max-[450px]:w-full'>
                            Restoran avadanlıqları ilə mətbəxinizi rahat şəkildə təchiz etmək üçün müasir və keyfiyyətli həllər təqdim edirik. Müştərilərimizin məmnuniyyəti üçün geniş çeşiddə məhsullar da mövcuddur.
                        </p>

                        <div className='flex items-center gap-[32px] max-[1210px]:gap-[16px]'>
                            <Link to='/products' className='p-[20px_30px] bg-[#EB4F26] rounded-[100px] font-[700] text-[22px] leading-[120%] text-[#fff] max-[650px]:p-[14px_22px] max-[650px]:text-[14px]'>
                                Keçid Et
                            </Link>

                            <Link to='/contact' className='font-[500] text-[22px] leading-[120%] text-[#222224] border-b-[3px] border-[#000] max-[650px]:text-[14px]'>Əlaqə</Link>
                        </div>
                    </div>

                    <img src={image1} className='w-full h-auto' />
                </div>



                <div className='flex justify-between items-center gap-[40px] max-[1210px]:flex-col max-[550px]:gap-[20px] max-[420px]:gap-[12px]'>
                    <img src={image2} className='w-full h-auto' />
                    <div className='flex flex-col gap-[30px] w-[380px] max-[1210px]:w-full max-[1210px]:items-center max-[1210px]:gap-[16px] max-[420px]:gap-[12px]'>
                        <h2 className='font-[500] text-[40px] leading-[120%] text-[#000] max-[650px]:text-[28px]'>
                            Market Avadalıqları</h2>
                        <p className='font-[400] text-[20px] leading-[150%] text-[#222224] max-[1210px]:w-[70%] max-[450px]:w-full max-[1210px]:text-center max-[650px]:text-[16px]'>
                            Məhsullarımız arasında müxtəlif tipli vitrin soyuducular, orta və divar rəfləri də mövcuddur, hər biri mağaza və marketlərdə məhsulların funksional və səliqəli nümayişini təmin edir.
                        </p>

                        <div className='flex items-center gap-[32px] max-[1210px]:gap-[16px]'>
                            <button className='p-[20px_30px] bg-[#EB4F26] rounded-[100px] font-[700] text-[22px] leading-[120%] text-[#fff] max-[650px]:p-[14px_22px] max-[650px]:text-[14px]'>
                                Keçid Et
                            </button>

                            <Link to='/contact' className='font-[500] text-[22px] leading-[120%] text-[#222224] border-b-[3px] border-[#000] max-[650px]:text-[14px]'>Əlaqə</Link>
                        </div>
                    </div>


                </div>
            </div>
        )
    }
}

export default MainSectionMP